function cov_1um9oc9r3q() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LocationPinFilled.tsx";
  var hash = "67f56c64585f16c836af8772736e8e10f58927b6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LocationPinFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 59
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "67f56c64585f16c836af8772736e8e10f58927b6"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1um9oc9r3q = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1um9oc9r3q();
var Icon = (cov_1um9oc9r3q().s[0]++, {
  name: 'location-pin-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.98959 4.2106C9.30905 0.891144 14.691 0.891144 18.0104 4.2106C21.3299 7.53006 21.3299 12.912 18.0104 16.2314L12 22.2418L5.98959 16.2314C2.67014 12.912 2.67014 7.53006 5.98959 4.2106ZM16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10Z\" fill=\"currentColor\"/>"
});
export default Icon;